import Svg, { Path } from '@rd-core-svg/svg'
import type { LogoSvgProps } from '../svg.types'

export const RaiaColoredSymbol = (props: LogoSvgProps) => {
  return (
    <Svg {...props} viewBox="0 0 65 64" fill="none">
      <Path
        d="M36.5467 0.728341C35.3326 -0.56782 33.8272 -0.0297915 33.9 1.57207L34.8106 17.6518C35.1869 24.9641 39.3512 29.2317 46.6113 29.6107L62.5763 30.5278C64.1667 30.6012 64.6159 29.1583 63.414 27.8621L36.5467 0.728341Z"
        fill="#7DCE73"
      />
      <Path
        d="M62.5642 33.487L46.6113 34.3919C39.3512 34.7709 35.1869 39.0385 34.8106 46.3508L33.9 62.4305C33.8272 64.0324 35.3326 64.5582 36.5467 63.2743L63.4019 36.1527C64.6038 34.8565 64.1546 33.4014 62.5642 33.487Z"
        fill="#7DCE73"
      />
      <Path
        d="M29.2866 46.3634C28.9102 39.0511 24.746 34.7836 17.4858 34.4045L1.52083 33.4874C-0.0695959 33.4141 -0.5188 34.9303 0.683127 36.1531L27.5504 63.2747C28.7645 64.5709 30.27 64.0328 30.1971 62.431L29.2866 46.3634Z"
        fill="#7DCE73"
      />
      <Path
        d="M27.5509 0.729458L0.695747 27.851C-0.518321 29.0738 -0.0569721 30.5901 1.53346 30.5167L17.4984 29.5996C24.7586 29.2206 28.9228 24.953 29.2992 17.6407L30.2097 1.56096C30.2704 -0.0409002 28.7529 -0.566704 27.5509 0.729458Z"
        fill="#7DCE73"
      />
    </Svg>
  )
}
